const maxAttempts = 3;
const sleepTime = 1000;

export default class GoogleApiService {
  constructor(apiHandler) {
    this.apiHandler = apiHandler;
    this.googleApiClient = null;
    this.nbAttempts = 0;
    this.initGooGleApiClient();
  }

  initGooGleApiClient() {
    this.apiHandler.initClient()
      .then((client) => {
        this.googleApiClient = client;
      })
      .catch(() => {
        if (this.nbAttempts < maxAttempts) {
          setTimeout(this.initGooGleApiClient, sleepTime);
          this.nbAttempts += 1;
        }
      });
  }

  searchbyAddress(address) {
    return new Promise((resolve) => {
      this.apiHandler.getGeocoder()
        .then((geocoder) => {
          geocoder.geocode({ address, region: 'AU' }, (results, status) => {
            if (status === 'OK' && results && results.length > 0) {
              const filterSearchResults = this.apiHandler.filterGeocode(results, true)
                .map((x) => {
                  // console.log(x);
                  const r = x.formatted_address.split(',').slice(0, 2).join('');
                  return {
                    id: null,
                    address: r,
                    details: this.apiHandler.parseGeocode(x),
                  };
                }).filter(x => !!x);
              resolve(filterSearchResults);
            } else {
              resolve([]);
            }
          });
        // })
        // .catch((error) => {
        //   console.error('Error while retrieving the geocoder');
        //   console.error(error);
        });
    });
  }

  LatLngBounds() {
    return new this.googleApiClient.maps.LatLngBounds();
  }

  LatLng(latitude, longitude) {
    return new this.googleApiClient.maps.LatLng(latitude, longitude);
  }

  Map(element, options) {
    return new this.googleApiClient.maps.Map(element, options);
  }

  Marker(data) {
    return new this.googleApiClient.maps.Marker(data);
  }

  Circle(data) {
    return new this.googleApiClient.maps.Circle(data);
  }

  InfoWindow(data) {
    return new this.googleApiClient.maps.InfoWindow(data);
  }
}
